import { atom } from "jotai";
import openedWindowIdsAtom from "app/uiState/openedWindowIdsAtom";
import getWindowAtom from "app/uiState/getWindowAtom";
import { type ComponentState, type ComponentName } from "app/componentOptions";

// Intentionally read-only as reads from openWindowIds and getWindowAtom
const openedWindowsAtom = atom((get) => {
  const ids = get(openedWindowIdsAtom);
  return ids.reduce<Record<string, ComponentState<ComponentName>>>(
    (acc, id) => {
      const windowAtom = getWindowAtom(id);
      const window = get(windowAtom);
      if (window) {
        acc[id] = window;
      }
      return acc;
    },
    {}
  );
});

export default openedWindowsAtom;
